'use strict';

angular.module('nfseApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('debitos', {
                parent: 'entity',
                url: '/consutar-debitos',
                data: {
                    roles: ['ROLE_EMPRESA_CONTA_CORRENTE'],
                    pageTitle: 'Conta Corrente'
                },
                ncyBreadcrumb: {
                    label: 'Consulta de Débitos'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/debitos/debitos.html',
                        controller: 'DebitosController'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('situacaoParcela');
                        return $translate.refresh();
                    }]
                }
            });
    });
